import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type CalloutCardProps = {
  title: string
  description?: string
  /** Media slot — pass ImagePlaceholder or a real image. */
  media?: React.ReactNode
  className?: string
  children?: React.ReactNode
}

/** Media inset beside short copy (phone mock, geo callout, etc.). */
function CalloutCard({ title, description, media, className, children }: CalloutCardProps) {
  return (
    <div
      data-slot="callout-card"
      className={cn('overflow-hidden rounded-xl border border-border bg-card shadow-sm', className)}
    >
      <div className={cn('grid gap-4 p-4', media && 'tablet:grid-cols-[minmax(0,140px)_1fr] tablet:items-center')}>
        {media ? <div className="min-w-0">{media}</div> : null}
        <div className="flex flex-col gap-2">
          <p className="text-body-bold text-card-foreground">{title}</p>
          {description ? <p className="text-body-sm text-muted-foreground">{description}</p> : null}
          {children}
        </div>
      </div>
    </div>
  )
}

export { CalloutCard }
export type { CalloutCardProps }
